import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getCatalogoDePadrones } from 'api/catalogos';
import { getSistemas } from 'api/recaudacion/sistemas';
import { getCuentasDeBanco } from 'api/configuracion/cuentasDeBancos';
import { getReceptoresDePagos } from 'api/catalogos/receptoresDePagos';
import {
  getTiposDeReferenciaDePagos,
  postTipoDeRefrenciaDePago,
  patchTipoDeRefrenciaDePago,
  deleteTipoDeRefrenciaDePago,
} from 'api/catalogos/tiposDeReferenciasDePago';

const catalogs = [
  {
    permission: 'padron',
    get: getCatalogoDePadrones,
    formItemName: 'padrones',
  },
  {
    permission: 'sistemas',
    get: getSistemas,
    formItemName: 'sistema',
  },
  {
    permission: 'cuentadebanco',
    get: getCuentasDeBanco,
    formItemName: 'cuenta_de_banco',
  },
  {
    permission: 'receptoresdepagos',
    get: getReceptoresDePagos,
    formItemName: 'receptor_de_pago_emitido',
  },
];

export const permissionConfig = {
  permissionModel: 'tiposdereferenciasdepagos',
  catalogsModels: catalogs.map((c) => c.permission),
};

// eslint-disable-next-line react/prop-types
const TiposDeReferenciasDePago = ({ permission }) => (
  <PlainCRUD
    title="Tipo de Referencia de Pago"
    permission={permission}
    get={getTiposDeReferenciaDePagos}
    post={postTipoDeRefrenciaDePago}
    patch={patchTipoDeRefrenciaDePago}
    delete={deleteTipoDeRefrenciaDePago}
    fields={[
      defaultFields.descripcion,
      {
        name: 'clave_convenio_de_operacion_de_receptor',
        label: 'Clave de Convenio de Operación',
        // required: true,
        colWidth: 200,
      },
      {
        name: 'mascara_convenio_de_operacion_de_receptor',
        label: 'Máscara de Convenio de Operación',
        // required: true,
        colWidth: 200,
      },
      {
        name: 'padrones',
        label: 'Padron',
        render: (item) => item?.descripcion,
        type: 'select',
        required: true,
        useCatalog: true,
      },
      {
        name: 'sistema',
        label: 'Sistema',
        render: (item) => item?.descripcion,
        type: 'select',
        required: true,
        useCatalog: true,
      },
      {
        name: 'cuenta_de_banco',
        label: 'Cuenta de Banco',
        render: (item) => `${item?.numero_de_cuenta} - ${item?.finalidad}`,
        type: 'select',
        required: true,
        useCatalog: true,
      },
      {
        name: 'receptor_de_pago_emitido',
        label: 'Receptor de Pago Emitido',
        labelProp: 'descripcion',
        type: 'select',
        required: true,
        useCatalog: true,
      },
      {
        name: 'utiliza_clabe_interbancaria',
        label: '¿Utiliza Clabe Interbancaria?',
        type: 'select',
        required: true,
      },
      {
        name: 'utilizar_en_transferencias',
        label: '¿Utilizar en Transferencias?',
        type: 'select',
        required: true,
      },
    ]}
    catalogs={catalogs}
  />
);

export default TiposDeReferenciasDePago;
